module.exports = __webpack_public_path__ + "img/step01.6b78b1ca.png";